<template>
  <div class="pc-course">
    <BreadCrumb :data="breadcrumb" :title="'课程列表管理'" />
    <h1 class="pc-banner-head">课程系列</h1>
        <div class="pc-list" ref="list">
      <h2 class="pc-banner-title">课程系列管理</h2>
      <el-table
        class="pc-list-table"
        :data="seriesList"
      >
        <el-table-column fixed prop="id" label="ID" width="170">
          <template slot-scope="scope">
            <span v-show="lectureStatus != scope.$index">
              {{ scope.row.id }}
              </span
            >
            <el-input
              v-model="scope.row.id"
              v-show="lectureStatus == scope.$index"
              placeholder=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column width="150">
          <template slot-scope="scope">
            <button
              v-if="lectureStatus == scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="lectureDetail(scope)"
            >
              查看
            </button>
          </template>
        </el-table-column>
        <el-table-column prop="cover_image" label="图片" width="170">
          <template slot-scope="scope">
            <img :src="scope.row.cover_image" alt="" class="cover_images" />
          </template>
        </el-table-column>
        <el-table-column prop="chinese_title" label="中文标题" width="230">
          <template slot-scope="scope">
            <span>{{ scope.row.chinese_title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="english_title" label="英文标题" width="230">
          <template slot-scope="scope">
            <span>{{ scope.row.english_title }}</span>
          </template>
        </el-table-column>

        <el-table-column width="220">
          <template slot-scope="scope">
            <button
              v-show="lectureStatus != scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="viewDetail(scope.row, scope.$index)"
            >
              修改
            </button>
            <button
              v-show="lectureStatus == scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="finishDetail(scope.row)"
            >
              完成
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pc-list" ref="list">
      <h2 class="pc-banner-title">课程banner管理</h2>
      <el-table
        class="pc-list-table"
        :data="bannerList"
      >
        <el-table-column fixed prop="id" label="ID" width="170">
          <template slot-scope="scope">
            <span v-show="lectureStatus != scope.$index">
              {{ scope.row.id }}
              </span
            >
            <el-input
              v-model="scope.row.id"
              v-show="lectureStatus == scope.$index"
              placeholder=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column width="150">
          <template slot-scope="scope">
            <button
              v-if="lectureStatus == scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="lectureDetail(scope)"
            >
              查看
            </button>
          </template>
        </el-table-column>
        <el-table-column prop="cover_image" label="图片" width="170">
          <template slot-scope="scope">
            <img :src="scope.row.cover_image" alt="" class="cover_images" />
          </template>
        </el-table-column>
        <el-table-column prop="chinese_title" label="中文标题" width="230">
          <template slot-scope="scope">
            <span>{{ scope.row.chinese_title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="english_title" label="英文标题" width="230">
          <template slot-scope="scope">
            <span>{{ scope.row.english_title }}</span>
          </template>
        </el-table-column>

        <el-table-column width="220">
          <template slot-scope="scope">
            <button
              v-show="lectureStatus != scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="viewDetail(scope.row, scope.$index)"
            >
              修改
            </button>
            <button
              v-show="lectureStatus == scope.$index && rankType == 'update'"
              class="btnViewDetail"
              @click="finishDetail(scope.row)"
            >
              完成
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import BreadCrumb from "@/components/componentSet/BreadCrumb";
import { getLectureList_Api, getLecture_Api } from "@/apis/lecture.api";
export default {
  components: {
    BreadCrumb,
  },
  data() {
    return {
      seriesList:[],
      bannerList: [],
      lectureStatus: -1,
      rankType: "update",
      position: null,
      lecture_id: null,
      id:null,
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "课程Banner管理", link: "/admin/lecturebanner" },
      ];
    },
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      getLectureList_Api().then((res) => {
        this.bannerList = res.data;
        console.log(res);
      });
    },
    viewDetail(item, index) {
      this.rankType = "update";
      this.lectureStatus = index;
      this.id =item.id
      console.log(item.id)
      console.log(index)
    },
    finishDetail() {
      this.lectureStatus = -1;
    },
    lectureDetail(item) {
      getLecture_Api((item.row.id)).then((res) => {
        // console.log(item);
        console.log(res);
        console.log(item.$index)
        console.log(this.bannerList)
        // item.row = res.data
        this.$set(this.bannerList,item.$index,res.data)
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pc-banner-head {
  font-size: 25px;
  padding: 20px 0;
  -ms-flex-item-align: end;
  align-self: flex-end;
}
.pc-list {
  padding: 42px 30px 57px;
  margin-bottom: 30px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  overflow: hidden;
  .pc-banner-title {
    font-size: 20px;
    padding: 0 0 30px 0;
    -ms-flex-item-align: end;
    align-self: flex-end;
  }
  .pc-list-head {
    // margin-top: 20px;
    // margin-bottom: 30px;
    margin: 20px 0 30px;
    border-top: 1px solid #c0c0c0;
    padding-top: 30px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    display: flex;
    justify-content: flex-end;
    .pc-list-head-handle {
      // float: right;
      display: flex;
      align-items: center;
      .pc-list-head-btn {
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $mainTitle;
          letter-spacing: 1px;
        }
        button {
          width: 100px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }
        button:hover {
          background: $blueBtn;
          color: white;
        }
        p {
          margin-left: 32px;
        }
      }
    }
  }

  /deep/ .el-table__row {
    height: 60px;
    .el-input {
      .el-input__inner {
        height: 30px;
        text-align: center;
        width: 80px;
      }
      .el-select__caret {
        line-height: 30px;
      }
    }
    .el-input--suffix {
      .el-input__inner {
        width: 100%;
      }
    }
  }
  .pc-list-table::-webkit-scrollbar {
    height: 10px;
    background: red;
  }
  .pc-list-table {
    overflow: visible !important;
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $blueBtn;
      color: white;
    }
    /deep/ .cell {
      text-align: center !important;
      font-family: $chinese !important;
      font-size: 14px !important;
      color: $mainTitle !important;
      .el-icon-error {
        font-size: 18px;
        margin-right: 20px;
        color: $fork;
      }
      .el-icon-success {
        font-size: 18px;
        color: $blueBtna;
      }
    }

    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }
    .cover_images {
      width: 70px;
      height: 45px;
    }
    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
    /deep/ .el-table__body-wrapper {
      min-height: 100px;
    }
    /deep/ .is-leaf {
      border-top: 1px solid #ebeef5;
      background: $base-color !important;
      font-weight: normal !important;
    }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
  }

  .pagination {
    margin-top: 40px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
.lecture-recommend {
  @include box-model;
}
</style>





// WEBPACK FOOTER //
// src/components/admin/lecture/LectureBanner.vue